<template>
  <b-modal
    id="documentHistoryModal"
    ref="documentHistoryModal"
    :no-enforce-focus="true"
    :no-close-on-backdrop="true"
    :scrollable="true"
    size="xl"
    @hidden="modalDocumentHistoryHidden"
  >
    <div slot="modal-title">
      {{ title }}
      <span class="ml-2">-</span>
      <span class="font-weight-bold ml-2">{{ `${this.clientName} - ${this.agreementTitle}` }}</span>
    </div>
    <DocumentHistoryList :agreement-id="agreementId "/>
    <div slot="modal-footer">
      <b-btn class="mr-2" variant="primary" @click="modalDocumentHistoryHidden">
        {{ 'OK' | translate }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import DocumentHistoryList from './DocumentHistoryList'

export default {
  name: 'DocumentHistoryModal',
  components: { DocumentHistoryList },
  props: {
    agreementId: { required: true },
    clientName: { required: true },
    agreementTitle: { required: true }
  },
  mounted () {
    this.openDocumentHistoryModal()
  },
  computed: {
    title () {
      return `${this.$t('History')} ${this.$t('Agreement')}`
    }
  },
  methods: {
    // MODAL
    openDocumentHistoryModal () {
      this.$refs.documentHistoryModal.show()
    },
    modalDocumentHistoryHidden () {
      this.$emit('close')
      this.$refs.documentHistoryModal.hide()
    },
    onSubmit () {
      this.$emit('submit', this.form.file)
      this.modalDocumentHistoryHidden()
    }
  }
}
</script>
